import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute("/app/art/schedules")({
  component: Outlet,
  beforeLoad: ({ context: { t } }) => ({ getTitle: () => t && t("Schedules") }),
})
